var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import Rate from '../rates/RegularRate';
import _ from 'underscore';
function transformRate(rate, match, outcome, gridLocalization) {
    var rateWithName = rate;
    if (rate) {
        var sportId = match.get('realSportId');
        var matchObj = {
            homeTeam: match.get('firstTeam'),
            awayTeam: match.get('secondTeam')
        };
        var outcomeObj = outcome.toJS();
        var rateObj = rate.toJS();
        rateObj.shortName = gridLocalization.getRateName(sportId, outcomeObj, rate.get('type'), matchObj);
        rateWithName = Immutable.fromJS(rateObj);
    }
    return rateWithName;
}
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, outcome = _a.outcome, gridLocalization = _a.gridLocalization, section = _a.section, rates = _a.rates, match = _a.match;
        if (outcome === undefined) {
            return false;
        }
        var outcomeRates = {};
        outcome.get('rates')
            .entrySeq()
            .sortBy(function (r) { return r[0]; })
            .forEach(function (r) {
            outcomeRates[r[0]] = r[1];
        });
        var firstWinRates = rates.filter(function (rate) {
            var rateWithName = transformRate(rate, match, outcome, gridLocalization);
            var rateResults = rateWithName.get('shortName').split('-');
            return (parseInt(rateResults[0]) > parseInt(rateResults[1]) && rate.get('isVisible') === true);
        }).sortBy(function (rate) { return rate.get('type'); }).toArray();
        var drawRates = rates.filter(function (rate) {
            var rateWithName = transformRate(rate, match, outcome, gridLocalization);
            var rateResults = rateWithName.get('shortName').split('-');
            return (parseInt(rateResults[0]) === parseInt(rateResults[1]) && rate.get('isVisible') === true);
        }).sortBy(function (rate) { return rate.get('type'); }).toArray();
        var secondWinRates = rates.filter(function (rate) {
            var rateWithName = transformRate(rate, match, outcome, gridLocalization);
            var rateResults = rateWithName.get('shortName').split('-');
            return (parseInt(rateResults[0]) < parseInt(rateResults[1]) && rate.get('isVisible') === true);
        }).sortBy(function (rate) { return rate.get('type'); }).toArray();
        var zippedRates = _.zip(firstWinRates, drawRates, secondWinRates);
        var props = {
            gridLocalization: gridLocalization,
            section: section
        };
        var renderedRates = zippedRates.map(function (rates, i) {
            return (_jsx("div", __assign({ className: 'item' }, { children: _jsx("div", __assign({ className: 'rows' }, { children: rates.map(function (rate) {
                        var cell = _jsx("div", __assign({ className: 'cols' }, { children: _jsxs("a", __assign({ href: '#' }, { children: [_jsx("span", __assign({ className: 'label' }, { children: "\u00A0" })), _jsx("span", { className: 'rate' })] })) }), "".concat(i, "-").concat(Math.random()));
                        if (rate) {
                            cell = _jsx("div", __assign({ className: 'cols' }, { children: _createElement(Rate, __assign({}, props, { id: rate.get('id'), key: rate.get('id') })) }), "".concat(i, "-").concat(Math.random()));
                        }
                        return cell;
                    }) })) }), i));
        });
        return (_jsx("div", __assign({ className: 'items toggle_content' }, { children: renderedRates })));
    };
    default_1.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        outcome: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired
    };
    return default_1;
}(React.Component));
export default default_1;
;



// WEBPACK FOOTER //
// ./src/components/grid/event/outcomes/CorrectScoreOutcome.jsx